import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import O2TooltipPopoverWrapper, { propTypes } from "./o2-tooltip-popover-wrapper";

var O2Popover = function O2Popover(props) {
  var children = props.children,
      hideArrow = props.hideArrow,
      placementPrefix = props.placementPrefix,
      size = props.size,
      className = props.className,
      internal = props.internal,
      atributes = _objectWithoutPropertiesLoose(props, ["children", "hideArrow", "placementPrefix", "size", "className", "internal"]);

  var popperClasses = classNames("o2-popover", className, "show", size ? "o2-popover--" + size : false, {
    "o2-popover--internal": internal
  });
  var classes = classNames("popoverIner", props.innerClassName);
  return /*#__PURE__*/React.createElement(O2TooltipPopoverWrapper, _extends({}, atributes, {
    placementPrefix: hideArrow ? "" : placementPrefix,
    popperClassName: popperClasses,
    innerClassName: classes,
    invertedArrow: true
  }), !hideArrow && /*#__PURE__*/React.createElement("div", {
    className: "o2-popover__arrow"
  }), /*#__PURE__*/React.createElement("div", {
    className: "o2-popover__container"
  }, children));
};

O2Popover.propTypes = _objectSpread({
  hideArrow: PropTypes.bool,
  internal: PropTypes.bool,
  size: PropTypes.oneOf(["scrollable", "complex"])
}, propTypes);
O2Popover.defaultProps = {
  placement: "bottom",
  placementPrefix: "o2-popover-",
  trigger: "legacy",
  flip: false,
  fade: true
};
export default O2Popover;